/** @format */

import { simCardConstants } from './actions';
import { reducerDebug } from '../../core/debug';

export function simCardDynamicReducers(state = {}, action) {
    reducerDebug('SimCard dynamic reducer: ' + action.type);
    reducerDebug(action);
    switch (action.type) {
        case simCardConstants.D_SIM_CARD_LOAD_ITEM:
            return {
                type: action.type,
                item: action.item,
            };
        default:
            return {
                ...state,
                type: action.type,
            };
    }
}

export function simCardReducers(state = {}, action) {
    reducerDebug('SimCard reducer: ' + action.type);
    switch (action.type) {
        case simCardConstants.SIM_CARD_LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case simCardConstants.SIM_CARD_ADD:
            return {
                type: action.type,
                success: true,
            };
        case simCardConstants.SIM_CARD_TARIFF_ICCID:
            return {
                type: action.type,
                tariffs: action.collections,
            };
        case simCardConstants.SIM_CARD_EDIT_ITEM:
            return {
                type: action.type,
                item: action.item,
            };
        case simCardConstants.SIM_CARD_SERVICES_GET_ALL:
            return {
                services: action.collections,
            };
        case simCardConstants.SIM_CARD_CHANGE_MSISDN_REQUEST:
            return {
                changetMsisdn: true,
            };
        default:
            return {
                ...state,
                type: action.type,
            };
    }
}
